import { z } from "zod";
import { WebsiteCrawlConfigSchema } from "../../website-config/schemas";

// Shared with AdminWebsiteCreateRequestSchema so creation and settings edits
// use the same display-name model.
export const WebsiteDisplayNameSchema = z.string().min(1);

// Full replacement of the editable set. Identity (originUrl, client) is
// immutable — pointing Faro at a different site means creating a new project.
export const WebsiteSettingsUpdateRequestSchema = z.object({
  // null clears the display name; the UI falls back to the client name.
  displayName: WebsiteDisplayNameSchema.nullable(),
  config: WebsiteCrawlConfigSchema,
});

export type WebsiteSettingsUpdateRequest = z.infer<
  typeof WebsiteSettingsUpdateRequestSchema
>;

// Response twin for GET and PATCH /websites/:websiteId/settings.
export const WebsiteSettingsResponseSchema = z.object({
  websiteId: z.uuid(),
  clientId: z.uuid(),
  clientName: z.string(),
  originUrl: z.url(),
  displayName: WebsiteDisplayNameSchema.nullable(),
  config: WebsiteCrawlConfigSchema,
  configVersion: z.number().int(),
});

export type WebsiteSettingsResponse = z.infer<
  typeof WebsiteSettingsResponseSchema
>;

export const WebsiteDeleteResponseSchema = z.object({
  websiteId: z.uuid(),
  deletedAt: z.iso.datetime(),
});

export type WebsiteDeleteResponse = z.infer<typeof WebsiteDeleteResponseSchema>;
